import React from 'react';
import { Box, Typography, LinearProgress } from '@material-ui/core';
import { ReportCardComponentProps } from '../schema-types';
import { filterDOMProps } from '../utils/prop-normalizer';

interface ProgressBarItem {
  label: string;
  value: number;
  maxValue?: number;
  color?: string;
  backgroundColor?: string;
  description?: string;
}

interface ProgressBarData {
  title?: string;
  items: ProgressBarItem[];
  showValues?: boolean;
  orientation?: 'horizontal' | 'vertical';
  height?: number;
  spacing?: number;
}

export const ProgressBarComponent: React.FC<ReportCardComponentProps> = ({
  data,
  baseData: _baseData,
  player: _player,
  playerAssessment: _playerAssessment,
  reportCardLevel: _reportCardLevel,
  context: _context,
  ...props
}) => {
  const {
    title,
    items = [],
    showValues = true,
    orientation = 'horizontal',
    height = 8,
    spacing = 2
  }: ProgressBarData = data || {};

  return (
    <Box mb={3} {...filterDOMProps(props)}>
      {title && (
        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', textAlign: 'center' }}>
          {title}
        </Typography>
      )}

      <Box display="flex" flexDirection="column">
        {items.map((item, index) => {
          const maxValue = item.maxValue || 100;
          const percentage = Math.min((item.value / maxValue) * 100, 100);

          return (
            <Box key={index} mb={spacing}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  {item.label}
                </Typography>
                {showValues && (
                  <Typography variant="body2" style={{ color: '#666' }}>
                    {item.value}/{maxValue}
                  </Typography>
                )}
              </Box>

              <Box position="relative">
                <LinearProgress
                  variant="determinate"
                  value={percentage}
                  style={{
                    height: height,
                    borderRadius: height / 2,
                    backgroundColor: item.backgroundColor || '#e0e0e0'
                  }}
                />
              </Box>

              {item.description && (
                <Typography variant="caption" style={{ color: '#666', marginTop: 4 }}>
                  {item.description}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
